import type { VideoLayoutProps } from '../model/types'

import { Captions, Controls, Gesture } from '@vidstack/react'

import { FullscreenButton, MuteButton, PlayButton } from './buttons'
import { Quality } from './menus'
import { TimeSlider, VolumeSlider } from './sliders'
import { TimeGroup } from './time-group'
import { Title } from './title'

export function VideoLayout({ thumbnails }: VideoLayoutProps) {
	return (
		<>
			<Gestures />
			<Captions className='media-preview:opacity-0 media-controls:bottom-[85px] media-captions:opacity-100 absolute inset-0 bottom-2 z-10 break-words transition-[opacity,bottom] duration-300 select-none' />
			<Controls.Root className='absolute inset-0 z-10 flex h-full w-full flex-col opacity-0 transition-opacity data-[visible]:opacity-100'>
				<div className='flex-1' />
				<div className='flex w-full flex-col items-center bg-linear-to-t from-black/50 to-transparent'>
					<Controls.Group className='flex w-full items-center px-2'>
						<TimeSlider thumbnails={thumbnails} />
					</Controls.Group>
					<Controls.Group className='flex w-full items-center px-2 pb-2'>
						<PlayButton />
						<MuteButton />
						<VolumeSlider />
						<TimeGroup />
						<Title />
						<div className='flex-1' />
						<Quality />
						<FullscreenButton />
					</Controls.Group>
				</div>
			</Controls.Root>
		</>
	)
}

function Gestures() {
	return (
		<>
			<Gesture
				className='absolute inset-0 z-0 block h-full w-full'
				event='pointerup'
				action='toggle:paused'
			/>
			<Gesture
				className='absolute inset-0 z-0 block h-full w-full'
				event='dblpointerup'
				action='toggle:fullscreen'
			/>
			<Gesture
				className='absolute top-0 left-0 z-10 block h-full w-1/5'
				event='dblpointerup'
				action='seek:-10'
			/>
			<Gesture
				className='absolute top-0 right-0 z-10 block h-full w-1/5'
				event='dblpointerup'
				action='seek:10'
			/>
		</>
	)
}
